const n = (e, t, r) => {
  const s = `${e ?? ""} ${t ?? ""}`.trim(), l = `${r ?? ""} ${t ?? ""}`.trim();
  return r ? l : s;
};
export {
  n as g
};
